import { Navigate, useLocation, useParams } from "react-router-dom";
import { urls } from "../../../urls";
import { v1SupplierViewLinkToCurrent } from "./v1SupplierViewLinkToCurrent";

export const LegacySupplierViewLinkRedirect = () => {
  const { eventId } = useParams();
  const location = useLocation();

  if (!eventId) return <Navigate to={urls.app.supplier.procurements} replace />;

  return <Navigate to={v1SupplierViewLinkToCurrent(eventId, location.search)} replace />;
};
